export class MultiActionStep {
  public icon?: string;
  public secondaryIcon?: string;
  public pictogram?: string;
  public text?: string;
}
